<script setup lang="ts">
import type { BadgeProps } from '#layers/ui/components/Badge.vue';
import { computed } from 'vue';
import { RoundedVariant } from '#layers/ui/components/Badge.vue';

const { segments, showRemove = false, variant = 'soft', color = 'info', size = 'sm' } = defineProps<{
	segments: string[];
	showRemove?: boolean;
	variant?: 'soft' | 'subtle';
	color?: BadgeProps['color'];
	size?: BadgeProps['size'];
}>();

defineEmits<{
	remove: [];
}>();

const leadingSegments = computed(() => segments.slice(0, -1));
const lastSegment = computed(() => segments.at(-1) ?? '');
</script>

<template>
	<DBadge :color :variant :size :rounded="RoundedVariant.Normal" class="leading-none">
		<span class="inline-flex items-center gap-1">
			<template v-for="(segment, index) in leadingSegments" :key="index">
				<span>{{ segment }}</span>
				<DIcon name="lucide:chevron-right" class="size-3 opacity-70" />
			</template>
			<span>{{ lastSegment }}</span>
			<button
				v-if="showRemove"
				type="button"
				class="flex shrink-0 cursor-pointer items-center transition-opacity hover:opacity-70"
				:aria-label="$t('common.remove')"
				@click.stop="$emit('remove')"
			>
				<DIcon name="lucide:x" class="size-3" />
			</button>
		</span>
	</DBadge>
</template>
